import * as C from 'actions/constants';
import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';

import AnswerIdentifiersReducer from './lib/answerIdentifiers';
import SessionReducer from './lib/session';
import FilterReducer from './lib/filter';
import ExportReducer from './lib/export';
import InsightsReducer from './insights';
import CategoryReducer from './lib/category';
import AllCategoriesReducer from './lib/allCategories';
import CompaniesReducer from './lib/companies';
import ReportsReducer from './lib/reports';
import FeedbacksReducer from './lib/feedbacks';
import GalleryReducer from './lib/gallery';
import PhotoTagsReducer from './lib/photoTags';
import CampaignsReducer from './lib/campaigns';
import CurrentUserReducer from './lib/currentUser';
import WidgetsReducer from './lib/widgets';
import SavedFiltersReducer from './lib/savedFilters';
import DefaultSavedFiltersReducer from './lib/defaultSavedFilters';

export const appReducer = combineReducers({
  answerIdentifiers: AnswerIdentifiersReducer,
  session: SessionReducer,
  filter: FilterReducer,
  export: ExportReducer,
  insights: InsightsReducer,
  category: CategoryReducer,
  allCategories: AllCategoriesReducer,
  companies: CompaniesReducer,
  reports: ReportsReducer,
  feedbacks: FeedbacksReducer,
  gallery: GalleryReducer,
  photoTags: PhotoTagsReducer,
  campaigns: CampaignsReducer,
  widgets: WidgetsReducer,
  currentUser: CurrentUserReducer,
  form: reduxFormReducer,
  savedFilters: SavedFiltersReducer,
  defaultSavedFilters: DefaultSavedFiltersReducer,
});

const rootReducer = (state, action) => {
  const newState = ((type) => {
    switch (type) {
      case C.SIGN_OUT:
        return { session: { data: {}, loading: true } };
      case C.SIGN_OUT_SUCCESS:
        return { session: { data: {}, loading: false } };
      case C.SET_COMPANY: {
        const { session, currentUser } = state;
        return { session, currentUser };
      }
      default:
        return state;
    }
  })(action.type);

  return appReducer(newState, action);
};

export default rootReducer;
